import { StorePagination } from "../../../../DashboardPagination";
import { fileActions } from "../../../../../store/files-slice";

export default function Pagination({ index }) {
    return <StorePagination index={index} sliceName="file" actions={fileActions} label="Dateien Seitennavigation" />;
}
